import { FC } from 'react';

import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanType } from 'store/useBusinessToolStore/selectors';

import { checkIsOnePageBP } from 'pages/BusinessToolPage/utils';

import { ShareDocumentButton } from 'components/ShareDocumentButton/ShareDocumentButton';
import { ShareOnePage } from 'components/ShareOnePage';

export const ShareDocumentWrapper: FC = () => {
  const bpType = useBusinessToolStore(getBusinessPlanType);
  const isOnePageBP = checkIsOnePageBP(bpType);

  if (isOnePageBP) {
    return <ShareOnePage />;
  }

  return <ShareDocumentButton />;
};
